/* tslint:disable */
/* eslint-disable */

/**
 * 0 = CommentsTab
 * 
 * 1 = CustomerTab
 * 
 * 2 = PreliminaryTab
 * 
 * 3 = FaultTab
 * 
 * 4 = CalibrationTab
 * 
 * 5 = QuotationCertificate
 * 
 * 6 = ExaminationReport
 * 
 * 7 = CalibrationCertificate
 * 
 * 8 = EditCalibration
 * 
 * 9 = DispatchNotesTab
 */
export enum LastOpenedFeature {
  CommentsTab = 0,
  CustomerTab = 1,
  PreliminaryTab = 2,
  FaultTab = 3,
  CalibrationTab = 4,
  QuotationCertificate = 5,
  ExaminationReport = 6,
  CalibrationCertificate = 7,
  EditCalibration = 8,
  DispatchNotesTab = 9
}
